module.exports = __webpack_public_path__ + "static/starlight-2c64475252de5b2a7cc00bbd1feaf2b6.jpg";